import { useCallback, useEffect, useState } from "react";
import AdminTask from "./AdminTask"
import { useDispatch, useSelector } from "react-redux";
import { IAdminTask } from 'Model/IAdminTask'
import { getSaveAdminTaskvalue, getSaveAfeAdminTaskvalue, getSaveAssetAdminTaskvalue, setSavedStatus } from "Store/FleetManagement/FleetAdminTask/AdminTaskAction";
import userSelectors from "redux/UserProfile/selectors";
import Moment from "moment";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import { useNavigate } from "react-router-dom";
import navOperations from "redux/Navigation/operations";
import { setAdminTaskGridValues, setInitialTaskDetail } from 'Store/Component/FleetManagement/FleetManagementAction'
import { setFleetItemId } from "Store/AssetManagement/AssetNumber/AssetNumberAction";
import { CONSTANTS } from "client/utils/constants";
import purchaseOrderOperation from "../../../../../redux/PurchaseOrder/operations";
import moment from "moment";
import { setDispositionData, setTransferData } from "Store/OrderManagement/FleetProcessing/FleetProcessingAction";
import Validation from "../../Asset/TransferOrder/CreateNewRequisition/Disposition/dispositionValidation";
import SubChoiceValidation from "../../Asset/TransferOrder/CreateNewRequisition/Disposition/DispositionSubChoices/dispositionSubChoicesValidation";
import { getFleetAfeChangeLog, getFleetAssetChangeLog } from "Store/FleetManagement/FleetAssetChangeLog/FleetAssetChangeLogAction";
import { setAfeOrderHeaderDetail, setAssetOrderHeaderDetail } from "Store/FleetManagement/AssetFleetProcessing/AssetFleetProcessingAction";
import { commonDispValidation, popupInitialData } from "utils";

const AdminTaskContainer = (props: any) => {
    const { 
        isComplete,
        titleExists,
        setTitleExists } = props
    const dispatch = useDispatch();
    const itemType = props?.itemType
    const setAssignedToError = props?.setAssignedToError
    const assignedToError = props?.assignedToError
    const newAssetError = props?.newAssetError
    const setNewAssetError = props?.setNewAssetError
    const setNewAssetValue = props?.setNewAssetValue
    const taskList = props?.taskList
    const itemId = props?.itemId
    const attachmentChangeFleetId = props?.attachmentChangeFleetId
    const purchaseOrderStepperData = props?.purchaseOrderStepperData
    const setAttachmentChangeFleetId = props?.setAttachmentChangeFleetId
    const setAssetDeterminationValue = props?.setAssetDeterminationValue
    const requestFleetAssetDetails = props?.requestFleetAssetDetails;
    const assetDeterminationValue = props?.assetDeterminationValue
    const newAssetValue = props?.newAssetValue
    const assignedToValue = props?.assignedToValue
    const setAssignedToValue = props?.setAssignedToValue
    const [groupedItemDetail, setGroupedItemDetail] = useState<any>()
    const [isDateChanged, setIsDatechanged] = useState<any>(false)
    const dispatchStepperData = purchaseOrderOperation.dispatchSetPurchaseorderStepperData(dispatch);
    const navigate = useNavigate();
    const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
    const dispatchNav = navOperations.dispatchNav(dispatch);

    const {
        adminTaskGridValues,
        userDetails,
        SavedAdminTaskValue,
        initialTaskDetail,
        attachmentsList,
        linkedAttachment,
        savedStatus,
        assetDisposition,
        transferData,
        assetOrderHeaderDetail
    }: any = useSelector((state: any) => ({
        adminTaskGridValues: state.fleetAdminTaskReducer.adminTaskGridValues,
        userDetails: userSelectors.getUserDetails(state),
        SavedAdminTaskValue: state.adminTaskReducer.SavedAdminTaskValue,
        initialTaskDetail: state.fleetAdminTaskReducer.initialTaskDetail,
        attachmentsList: state.fleetAdminTaskReducer.attachmentList,
        linkedAttachment: state.fleetAdminTaskReducer.linkedAttachments,
        savedStatus: state.adminTaskReducer.savedStatus,
        assetDisposition: state.FleetProcessingReducer.dispositionData,
        transferData: state.FleetProcessingReducer.transferData,
        assetOrderHeaderDetail: state.AssetFleetProcessingReducer.assetOrderHeaderDetail
    }))

    useEffect(() => {
        if (itemType !== CONSTANTS.REQUISITION && adminTaskGridValues?.length) {
            if (taskList && taskList[0]?.fleetDetailId == SavedAdminTaskValue?.fleetItemlId) {
                setAssignedToValue(null)
                setTitleExists(null)
                if(itemType === CONSTANTS.AFEREQUEST) {
                    dispatch(getFleetAfeChangeLog(SavedAdminTaskValue?.fleetItemlId));
                } else {
                    dispatch(getFleetAssetChangeLog(SavedAdminTaskValue?.fleetItemlId));
                }
                setAttachmentChangeFleetId()
                setIsDatechanged(false)
                let adminTaskGridValuesTemp = adminTaskGridValues?.filter((item?: any) => item?.itemId != itemId)
                let listTemp: any = {}
                listTemp.itemId = itemId
                listTemp.taskList = SavedAdminTaskValue?.taskList
                adminTaskGridValuesTemp?.push(listTemp)
                dispatch(setAdminTaskGridValues(adminTaskGridValuesTemp))

                let initialTaskDetailTemp = initialTaskDetail?.filter((initialItem?: any) => initialItem?.itemId != itemId)
                initialTaskDetailTemp?.push(listTemp)
                dispatch(setInitialTaskDetail(initialTaskDetailTemp))

                let transferDataTemp = transferData ? JSON?.parse(JSON.stringify(transferData)) : []
                transferDataTemp?.map((transferItem?: any) => {
                    transferItem?.fleetAssetDetails?.map((transFleetItem?: any) => {
                      if (SavedAdminTaskValue?.fleetItemlId == transFleetItem?.fleetRequestDetailId) {
                        transFleetItem.fleetRequestTransDispoReactTaskListTrackings = SavedAdminTaskValue?.taskList
                        transFleetItem.itemStatus = SavedAdminTaskValue?.itemStatus
                        transFleetItem.fleetStatus = SavedAdminTaskValue?.fleetStatus
                      }
                    })
                  })
                dispatch(setTransferData(transferDataTemp))

                const assetOrderHeaderDetailTemp = assetOrderHeaderDetail ? JSON.parse(JSON.stringify(assetOrderHeaderDetail)) : {}
                if (assetOrderHeaderDetailTemp) {
                    assetOrderHeaderDetailTemp.orderStatus = SavedAdminTaskValue?.orderStatus
                    assetOrderHeaderDetailTemp.fleetRequestDetail = transferDataTemp
                }
                dispatch(setAssetOrderHeaderDetail(assetOrderHeaderDetailTemp))

                ///To Change (Item and Fleet status) after save
                let savedStatusTemp = savedStatus?.filter((statusItem?: any) => statusItem?.fleetItemId != SavedAdminTaskValue?.fleetItemlId)
                let saveObj: any = {}
                saveObj.fleetItemId = SavedAdminTaskValue?.fleetItemlId
                saveObj.itemStatus = SavedAdminTaskValue?.itemStatus
                saveObj.fleetStatus = SavedAdminTaskValue?.fleetStatus
                saveObj.orderStatus = SavedAdminTaskValue?.orderStatus
                saveObj.taskList = SavedAdminTaskValue?.taskList
                savedStatusTemp?.push(saveObj)
                dispatch(setSavedStatus(savedStatusTemp))
            }
        } else {
            if (taskList && taskList[0]?.fleetDetailId == SavedAdminTaskValue?.fleetItemlId) {
                setAttachmentChangeFleetId()
                setIsDatechanged(false)
            }
        }
    }, [SavedAdminTaskValue])

    useEffect(() => {
        if (itemType !== CONSTANTS.REQUISITION) {
            if (taskList) {
                let adminTaskGridValuesTemp = adminTaskGridValues?.length ? adminTaskGridValues?.filter((item?: any) => item?.itemId != itemId) : []
                let listTemp: any = {}
                listTemp.itemId = itemId
                listTemp.taskList = taskList
                adminTaskGridValuesTemp?.push(listTemp)
                dispatch(setAdminTaskGridValues(adminTaskGridValuesTemp))
                dispatch(setInitialTaskDetail(adminTaskGridValuesTemp))
            }
        }

    }, [taskList])

    const groupedValue = (taskList: any) => {
        const groupedValue = taskList?.reduce((acc: any[], cur: any) => {
            let obj: any = {}
            obj.Step = cur.step
            obj.StepId = cur?.stepId
            obj.Details = []
            let detailsTemp = taskList?.filter((item: any) => item.stepId == cur?.stepId)
            if (detailsTemp) {
                detailsTemp?.map((detailItem: any, _index: any) => {
                    const taskListTemp: IAdminTask = {
                        poFleetRequestTaskListTrackingId: detailItem?.poFleetRequestTaskListTrackingId,
                        fleetDetailId: detailItem?.fleetDetailId,
                        stepId: detailItem?.stepId,
                        step: detailItem?.step,
                        seqNo: detailItem?.seqNo,
                        taskDescription: detailItem?.taskDescription,
                        taskStatus: detailItem?.taskStatus,
                        isApplicable: !detailItem?.isApplicable,
                        comment: ((detailItem?.comment?.trim()?.length <= 0 || !detailItem?.comment) && (detailItem?.taskStatus == CONSTANTS?.ORDER_STATUS?.COMPLETED || detailItem?.taskStatus == CONSTANTS.ORDER_STATUS.NBYA)) ? "-" : detailItem?.comment,
                        commentError: "",
                        completedBy: detailItem?.completedBy,
                        completedOn: detailItem?.completedOn ? new Date(detailItem?.completedOn) : null,
                        isShowTextBox: !((detailItem?.taskStatus == CONSTANTS?.ORDER_STATUS?.COMPLETED || detailItem?.taskStatus == CONSTANTS.ORDER_STATUS.NBYA) || detailItem?.comment?.trim()?.length > 0),
                        isCommentEdited: false,
                        isDisabled: !!((detailItem?.taskStatus == CONSTANTS?.ORDER_STATUS?.COMPLETED || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED)),
                        created: detailItem?.created ? new Date(detailItem?.created) : null,
                        parentSeqNo: detailItem?.parentSeqNo ? detailItem?.parentSeqNo : null
                    }
                    obj.Details = obj.Details.concat(taskListTemp)
                })
            }
            if (acc.find((itemval: any) => itemval.StepId == cur.stepId)) {
                return acc;
            }
            acc = acc.concat(obj);
            return acc;
        }, []);

        setGroupedItemDetail(groupedValue)
    }

    useEffect(() => {
        if (adminTaskGridValues?.length && itemType !== CONSTANTS.REQUISITION) {
            for (let i = 0; i < adminTaskGridValues?.length; i++) {
                if (adminTaskGridValues[i]?.itemId == itemId) {
                    groupedValue(adminTaskGridValues[i]?.taskList)
                }
            }
        }
    }, [adminTaskGridValues])

    useEffect(() => {
        if (taskList?.length && itemType == CONSTANTS.REQUISITION) {
            groupedValue(taskList)
        }
    }, [taskList])

    useEffect(() => {
        if ((assetDeterminationValue != null || assetDeterminationValue != undefined) && assetDeterminationValue?.fleetDetailId == purchaseOrderStepperData?.fleetRequestDetailId) {
            handleSubmitonChange(null);
        }
    }, [assetDeterminationValue])

    useEffect(() => {
        if ((newAssetValue != null || newAssetValue != undefined) && newAssetValue?.fleetDetailId == purchaseOrderStepperData?.fleetRequestDetailId) {
            handleSubmitonChange(null);
        }
    }, [newAssetValue])

    useEffect(() => {
        if((assignedToValue != null || assignedToValue != undefined) && assignedToValue?.fleetDetailId == purchaseOrderStepperData?.fleetRequestDetailId){
            handleSubmitonChange(null);
            setAssignedToValue(null)
        }
    },[assignedToValue])

    useEffect(() => {
        if((titleExists != null || titleExists != undefined) && titleExists?.fleetDetailId == purchaseOrderStepperData?.fleetRequestDetailId){
            handleSubmitonChange(null);
            setTitleExists(null)
        }
    },[titleExists])

    const onChangeEstDeliveryDate = (date: any) => {
        setIsDatechanged(true)
        dispatchStepperData({
            ...purchaseOrderStepperData,
            estDeliveryDate: date
        })
    }

    const clearEstDeliveryDate = () => {
        setIsDatechanged(true)
        dispatchStepperData({
            ...purchaseOrderStepperData,
            estDeliveryDate: moment().add(15, 'd').toDate()
        })
    }

    const onChangeActDeliveryDate = (date: any) => {
        if (date != null) {
            setIsDatechanged(true)
            dispatchStepperData({
                ...purchaseOrderStepperData,
                actualDeliveryDate: date
            })
        }
    }

    const clearActDeliveryDate = () => {
        setIsDatechanged(true)
        dispatchStepperData({
            ...purchaseOrderStepperData,
            actualDeliveryDate: ""
        })
    }

    useEffect(() => {
        if (isDateChanged) {
            handleSubmitonChange(null)
        }
    }, [purchaseOrderStepperData?.actualDeliveryDate, purchaseOrderStepperData.estDeliveryDate])

    const handleClickComment = (e: any, Id: any, Step: any) => {
        e?.preventDefault()
        let groupTemp = [...groupedItemDetail]
        for (let i = 0; i < groupTemp?.length; i++) {
            for (let j = 0; j < groupTemp[i]?.Details?.length; j++) {

                if (groupTemp[i]?.Details[j]?.poFleetRequestTaskListTrackingId == Id && groupTemp[i]?.Details[j]?.step == Step && !isDisableOncomplete() && purchaseOrderStepperData?.itemStatus != CONSTANTS.ORDER_STATUS.CANCELLED && purchaseOrderStepperData?.itemStatus != CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR) {
                    groupTemp[i].Details[j].isShowTextBox = !groupTemp[i].Details[j].isShowTextBox
                    groupTemp[i].Details[j].isCommentEdited = true
                    if (groupTemp[i].Details[j].comment?.trim().length == 1 && groupTemp[i].Details[j].comment == "-") {
                        groupTemp[i].Details[j].comment = ""
                    }
                    setGroupedItemDetail(groupTemp)
                } else if (groupTemp[i]?.Details[j]?.comment?.length) {
                    groupTemp[i].Details[j].isShowTextBox = false
                    groupTemp[i].Details[j].isCommentEdited = false
                    setGroupedItemDetail(groupTemp)
                }
            }
        }
    }
    const handleBlurComment = (e: any, Id: any, Step: any) => {
        e?.preventDefault()
        let groupTemp = [...groupedItemDetail]
        for (let i = 0; i < groupTemp?.length; i++) {
            if (groupTemp[i]?.Step == Step) {
                for (let j = 0; j < groupTemp[i]?.Details?.length; j++) {
                    if (groupTemp[i]?.Details[j]?.poFleetRequestTaskListTrackingId == Id) {
                        groupTemp[i].Details[j].isShowTextBox = false
                        groupTemp[i].Details[j].isCommentEdited = false
                        setGroupedItemDetail(groupTemp)
                    }
                }
            }
        }
        handleSubmitonChange(Id)
    }
    const onChangeComment = (item: any, Id: any, Step: any) => {
        let groupTemp = [...groupedItemDetail]
        for (let i = 0; i < groupTemp?.length; i++) {
            if (groupTemp[i]?.Step == Step) {
                for (let j = 0; j < groupTemp[i]?.Details?.length; j++) {
                    if (groupTemp[i]?.Details[j]?.poFleetRequestTaskListTrackingId == Id) {
                        groupTemp[i].Details[j].comment = item?.target?.value
                        groupTemp[i].Details[j].isShowTextBox = true
                        groupTemp[i].Details[j].completedBy = userDetails?.firstName + " " + userDetails?.lastName
                        if (item?.target?.value?.length > 400) {
                            groupTemp[i].Details[j].commentError = "Please enter comment less than 400 characters"
                        } else {
                            groupTemp[i].Details[j].commentError = ""
                        }
                        setGroupedItemDetail(groupTemp)
                    }
                }
            }
        }
    }

    const handleChangeToggle = (e: any, item: any, Id: any, Step: any) => {
        let groupTemp = [...groupedItemDetail]
        for (let i = 0; i < groupTemp?.length; i++) {
            if (groupTemp[i]?.Step == Step) {
                for (let j = 0; j < groupTemp[i]?.Details?.length; j++) {
                    if (groupTemp[i]?.Details[j]?.poFleetRequestTaskListTrackingId == Id) {
                        if (item) {
                            groupTemp[i].Details[j].completedOn = null
                            groupTemp[i].Details[j].completedBy = userDetails?.firstName + " " + userDetails?.lastName
                        } else {
                            groupTemp[i].Details[j].completedOn = ""
                        }
                        groupTemp[i].Details[j].isApplicable = item
                        setGroupedItemDetail(groupTemp)
                    }
                }
            }
        }
        handleSubmitonChange(Id)
    }
    
    const handleDateChange = (date: any, Id: any, Step: any) => {
        if (date != null) {
            let groupTemp = [...groupedItemDetail]
            for (let i = 0; i < groupTemp?.length; i++) {
                if (groupTemp[i]?.Step == Step) {
                    for (let j = 0; j < groupTemp[i]?.Details?.length; j++) {
                        if (groupTemp[i]?.Details[j]?.poFleetRequestTaskListTrackingId == Id) {
                            groupTemp[i].Details[j].completedOn = date
                            groupTemp[i].Details[j].completedBy = userDetails?.firstName + " " + userDetails?.lastName
                            setGroupedItemDetail(groupTemp)
                        }
                    }
                }
            }
            handleSubmitonChange(Id)
        }
    }

    const handleClearCompletedOn = (isApplicable: any, date: any, comment:any, Id: any, Step: any) => {
        let groupTemp = [...groupedItemDetail]
        for (let i = 0; i < groupTemp?.length; i++) {
            if (groupTemp[i]?.Step == Step) {
                for (let j = 0; j < groupTemp[i]?.Details?.length; j++) {
                    if (groupTemp[i]?.Details[j]?.poFleetRequestTaskListTrackingId == Id && groupTemp[i].Details[j].completedOn && groupTemp[i].Details[j].comment != "" && !isApplicable) {
                        groupTemp[i].Details[j].comment = ""                      
                        groupTemp[i].Details[j].completedOn = null
                        groupTemp[i].Details[j].completedBy = userDetails?.firstName + " " + userDetails?.lastName
                        setGroupedItemDetail(groupTemp)
                    }else if(groupTemp[i]?.Details[j]?.poFleetRequestTaskListTrackingId == Id && isDisableOncomplete() && isApplicable){
                        groupTemp[i].Details[j].comment = ""                      
                        groupTemp[i].Details[j].completedOn = null
                        groupTemp[i].Details[j].isApplicable = false;
                        groupTemp[i].Details[j].completedBy = userDetails?.firstName + " " + userDetails?.lastName
                        setGroupedItemDetail(groupTemp)
                    }
                }
            }
        }
        if (((date || comment != "") && !isApplicable) || (isDisableOncomplete() && isApplicable)) {
            handleSubmitonChange(Id)
        }
    }

    const popupValue = (decriptionTxt: any) => {
        setPopupcontent({
            ...Popupcontent,
            titleImg: ConfirmationBee,
            title: "INFORMATION",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            outlineBtnText: "Ok",
            isSingleConfirmationBtn: true,
            popupOutlinebtnOnclick: () => {
                let initialTaskDetailTemp = initialTaskDetail ? JSON.parse(JSON.stringify(initialTaskDetail)) : []
                dispatch(setAdminTaskGridValues(initialTaskDetailTemp))
                if (itemType === CONSTANTS.REQUISITION && taskList) {
                    groupedValue(taskList)
                } 
                setPopupcontent({ ...Popupcontent, isDialogVisible: false })
            }
        });
    }

    const errors = [
        "assetDispositionNameError",
        "assetDispositionAddress1Error",
        "assetDispositionAddress2Error",
        "assetDispositionCityError",
        "assetDispositionStateError",
        "assetDispositionZipError",
        "assetDispositionPhoneError",
        "assetDispositionSalePriceError",
        "assetDispositionTotalPriceError",
        "assetLocationNameError",
        "assetLocationAddress1Error",
        "assetLocationAddress2Error",
        "assetLocationCityError",
        "assetLocationStateError",
        "assetLocationZipError",
        "assetLocationPhoneError",
        "assetLotionSalePriceError",
        "assetDispositionReasonCodeError",
        "assetDispositionSubChoiceError"
    ]

    const validate = () => {
        let validToShowMyCart = true;
        let dispositionTemp = JSON.parse(JSON.stringify(assetDisposition))
        dispositionTemp = commonDispValidation(assetDisposition, Validation, SubChoiceValidation, dispositionTemp, true)
        if (!dispositionTemp?.assetDispositionReasonCode?.trim().length) {
            dispositionTemp = {
                ...dispositionTemp,
                assetDispositionReasonCodeError: "Please select Reason Code"
            }
            validToShowMyCart = false;

        }
        dispatch(setDispositionData(dispositionTemp))
        for (let key in errors) {
            if (dispositionTemp[errors[key]]) {
                validToShowMyCart = false;
            }
        }

        return validToShowMyCart;
    }

    const validateDispValue = () => {
        let isValid = true;
        isValid = validate()
         if (isValid) {
            return true;
        } else {
            return false;
        }
    }

    const handleSubmitonChange = (Id: any) => {
        dispatch(setFleetItemId(itemId))
        let groupTemp = groupedItemDetail ? [...groupedItemDetail] : []
        let changedValues: any = [];
        let isValid = true;
        let assignedToErrorVal = "The Assigned to cannot be set to Unassigned if the item is not complete."
        let newAssetErrorVal = newAssetError?.filter((item:any) => item?.fleetId == purchaseOrderStepperData?.fleetRequestDetailId)
        let linkedAttachmentTemp = linkedAttachment?.filter((item: any) => item?.fleetItemId == purchaseOrderStepperData?.fleetRequestDetailId)
        if (Id != null) {
            if (!purchaseOrderStepperData?.assignedTo?.trim()?.length || purchaseOrderStepperData?.assignedTo == "Unassigned" || (itemType == CONSTANTS.TRANSFER && (!requestFleetAssetDetails?.transferReceivingBranch?.receivingCostCenter?.length || requestFleetAssetDetails?.transferReceivingBranch?.receivingCostCenter?.length == undefined || requestFleetAssetDetails?.transferReceivingBranch?.receivingCostCenterError?.length) || (itemType == CONSTANTS.REACTIVATION && purchaseOrderStepperData?.assetDetermination && (!purchaseOrderStepperData?.newAssetNumber?.toString().length || !purchaseOrderStepperData?.newAssetNumber || purchaseOrderStepperData?.newAssetNumber == 0) || newAssetErrorVal?.length) || (itemType == CONSTANTS.DISPOSITION && !validateDispValue()))) {
                let decriptionTxt
                if ((itemType == CONSTANTS.REQUISITION) && (!purchaseOrderStepperData?.assignedTo?.trim()?.length || purchaseOrderStepperData?.assignedTo == "Unassigned")) {
                    decriptionTxt = (
                        <>
                            <p>{assignedToErrorVal}</p>
                        </>
                    );
                    setAssignedToError(assignedToErrorVal)
                } else if (itemType == CONSTANTS.DISPOSITION) {
                    if ((!purchaseOrderStepperData?.assignedTo?.trim()?.length || purchaseOrderStepperData?.assignedTo == "Unassigned") && validateDispValue()) {
                        decriptionTxt = (
                            <>
                                <p>{assignedToErrorVal}</p>
                            </>
                        );
                        let isExist = assignedToError?.length ? assignedToError?.filter((item?: any) => item?.fleetId == purchaseOrderStepperData?.fleetRequestDetailId) : []
                        if (!isExist?.length) {
                            let obj: any = {}
                            obj.fleetId = purchaseOrderStepperData?.fleetRequestDetailId
                            obj.error = assignedToErrorVal
                            assignedToError?.push(obj)
                            setAssignedToError(assignedToError)
                        }
                    } else if ((purchaseOrderStepperData?.assignedTo?.trim()?.length && purchaseOrderStepperData?.assignedTo != "Unassigned") && !validateDispValue()) {
                        decriptionTxt = (
                            <>
                                <p>Please fill missing request details information.</p>
                            </>
                        );
                    } else {
                        decriptionTxt = (
                            <>
                                <p>1. {assignedToErrorVal}</p>
                                <p>2. Please fill missing request details information.</p>
                            </>
                        );
                        let isExist = assignedToError?.length ? assignedToError?.filter((item?: any) => item?.fleetId == purchaseOrderStepperData?.fleetRequestDetailId) : []
                        if (!isExist?.length) {
                            let obj: any = {}
                            obj.fleetId = purchaseOrderStepperData?.fleetRequestDetailId
                            obj.error = assignedToErrorVal
                            assignedToError?.push(obj)
                            setAssignedToError(assignedToError)
                        }
                    }
                }
                else if ((itemType == CONSTANTS.REACTIVATION)) {

                    if ((!purchaseOrderStepperData?.assignedTo?.trim()?.length || purchaseOrderStepperData?.assignedTo == "Unassigned") && ((purchaseOrderStepperData?.assetDetermination && purchaseOrderStepperData?.newAssetNumber?.toString()?.length && purchaseOrderStepperData?.newAssetNumber != 0 && purchaseOrderStepperData?.newAssetNumber != "") || (!purchaseOrderStepperData?.assetDetermination)) && !newAssetErrorVal?.length) {
                        decriptionTxt = (
                            <>
                                <p>{assignedToErrorVal}</p>
                            </>
                        );
                        let isExist = assignedToError?.length ? assignedToError?.filter((item?: any) => item?.fleetId == purchaseOrderStepperData?.fleetRequestDetailId) : []
                        if (!isExist?.length) {
                            let obj: any = {}
                            obj.fleetId = purchaseOrderStepperData?.fleetRequestDetailId
                            obj.error = assignedToErrorVal
                            assignedToError?.push(obj)
                            setAssignedToError(assignedToError)
                        }

                    } else if((purchaseOrderStepperData?.assignedTo?.trim()?.length && purchaseOrderStepperData?.assignedTo != "Unassigned") && (newAssetErrorVal?.length)){
                        
                        decriptionTxt = (
                            <>
                                <p>{newAssetErrorVal[0]?.error}</p>
                            </>
                        );

                    } else if ((purchaseOrderStepperData?.assignedTo?.trim()?.length && purchaseOrderStepperData?.assignedTo != "Unassigned") && (purchaseOrderStepperData?.assetDetermination && (!purchaseOrderStepperData?.newAssetNumber?.toString()?.length || purchaseOrderStepperData?.newAssetNumber == 0 || purchaseOrderStepperData?.newAssetNumber == "") )) {
                        decriptionTxt = (
                            <>
                                <p>Please enter New Asset#.</p>
                            </>
                        );
                        let isNewassetExist = newAssetError?.length ? newAssetError?.filter((item?: any) => item?.fleetId == purchaseOrderStepperData?.fleetRequestDetailId) : []
                        if (!isNewassetExist?.length) {
                            let obj: any = {}
                            obj.fleetId = purchaseOrderStepperData?.fleetRequestDetailId
                            obj.error = "Please Enter New Asset#"
                            newAssetError?.push(obj)
                            setNewAssetError(newAssetError)
                        }
                    } else if((!purchaseOrderStepperData?.assignedTo?.trim()?.length || purchaseOrderStepperData?.assignedTo == "Unassigned") && ((purchaseOrderStepperData?.assetDetermination && (!purchaseOrderStepperData?.newAssetNumber?.toString()?.length || purchaseOrderStepperData?.newAssetNumber == 0 || purchaseOrderStepperData?.newAssetNumber == "")))) {
                        decriptionTxt = (
                            <>
                                <p>1. {assignedToErrorVal}</p>
                                <p>2. Please enter New Asset#.</p>
                            </>
                        );
                        let isExist = assignedToError?.length ? assignedToError?.filter((item?: any) => item?.fleetId == purchaseOrderStepperData?.fleetRequestDetailId) : []
                        if (!isExist?.length) {
                            let obj: any = {}
                            obj.fleetId = purchaseOrderStepperData?.fleetRequestDetailId
                            obj.error = assignedToErrorVal
                            assignedToError?.push(obj)
                            setAssignedToError(assignedToError)
                        }
                        let newAssetErrorTemp = newAssetError?.length ? newAssetError?.filter((item?: any) => item?.fleetId != purchaseOrderStepperData?.fleetRequestDetailId) : []
                            let obj: any = {}
                            obj.fleetId = purchaseOrderStepperData?.fleetRequestDetailId
                            obj.error = "Please Enter New Asset#"
                            newAssetErrorTemp?.push(obj)
                            setNewAssetError(newAssetErrorTemp)
                    } else {
                        decriptionTxt = (
                            <>
                                <p>1. {assignedToErrorVal}</p>
                                <p>2. {newAssetErrorVal[0]?.error == "Please enter valid Asset #" ? "Please enter valid New Asset #" : newAssetErrorVal[0]?.error}</p>
                            </>
                        );
                        let isExist = assignedToError?.length ? assignedToError?.filter((item?: any) => item?.fleetId == purchaseOrderStepperData?.fleetRequestDetailId) : []
                        if (!isExist?.length) {
                            let obj: any = {}
                            obj.fleetId = purchaseOrderStepperData?.fleetRequestDetailId
                            obj.error = assignedToErrorVal
                            assignedToError?.push(obj)
                            setAssignedToError(assignedToError)
                        }
                        let newAssetErrorTemp = newAssetError?.length ? newAssetError?.filter((item?: any) => item?.fleetId != purchaseOrderStepperData?.fleetRequestDetailId) : []
                        let obj: any = {}
                        obj.fleetId = purchaseOrderStepperData?.fleetRequestDetailId
                        obj.error = newAssetErrorVal[0]?.error == "Please enter valid Asset #" ? "Please enter valid New Asset #" : newAssetErrorVal[0]?.error
                        newAssetErrorTemp?.push(obj)
                        setNewAssetError(newAssetErrorTemp)
                    }
                } else if (itemType == CONSTANTS.TRANSFER) {
                    if ((!purchaseOrderStepperData?.assignedTo?.trim()?.length || purchaseOrderStepperData?.assignedTo == "Unassigned") && (requestFleetAssetDetails?.transferReceivingBranch?.receivingCostCenter?.length) && !requestFleetAssetDetails?.transferReceivingBranch?.receivingCostCenterError?.length) {
                        decriptionTxt = (
                            <>
                                <p>{assignedToErrorVal}</p>
                            </>
                        );
                        let isExist = assignedToError?.length ? assignedToError?.filter((item?: any) => item?.fleetId == purchaseOrderStepperData?.fleetRequestDetailId) : []
                        if (!isExist?.length) {
                            let obj: any = {}
                            obj.fleetId = purchaseOrderStepperData?.fleetRequestDetailId
                            obj.error = assignedToErrorVal
                            assignedToError?.push(obj)
                            setAssignedToError(assignedToError)
                        }

                    } else if ((purchaseOrderStepperData?.assignedTo?.trim()?.length && purchaseOrderStepperData?.assignedTo != "Unassigned") && (!requestFleetAssetDetails?.transferReceivingBranch?.receivingCostCenter?.length) && !requestFleetAssetDetails?.transferReceivingBranch?.receivingCostCenterError?.length) {
                        decriptionTxt = (
                            <>
                                <p>Please select the Cost Center.</p>
                            </>
                        );
                    } else if ((purchaseOrderStepperData?.assignedTo?.trim()?.length && purchaseOrderStepperData?.assignedTo != "Unassigned") && (requestFleetAssetDetails?.transferReceivingBranch?.receivingCostCenter?.length) && requestFleetAssetDetails?.transferReceivingBranch?.receivingCostCenterError?.length) {
                        decriptionTxt = (
                            <>
                                <p>Please select another Cost Center.</p>
                            </>
                        );
                    } else if (((purchaseOrderStepperData?.assignedTo?.trim()?.length && purchaseOrderStepperData?.assignedTo == "Unassigned") && (requestFleetAssetDetails?.transferReceivingBranch?.receivingCostCenter?.length) && requestFleetAssetDetails?.transferReceivingBranch?.receivingCostCenterError?.length)) {
                        decriptionTxt = (
                            <>
                                <p>1. {assignedToErrorVal}</p>
                                <p>2. Please select another Cost Center.</p>
                            </>
                        );
                        let isExist = assignedToError?.length ? assignedToError?.filter((item?: any) => item?.fleetId == purchaseOrderStepperData?.fleetRequestDetailId) : []
                        if (!isExist?.length) {
                            let obj: any = {}
                            obj.fleetId = purchaseOrderStepperData?.fleetRequestDetailId
                            obj.error = assignedToErrorVal
                            assignedToError?.push(obj)
                            setAssignedToError(assignedToError)
                        }
                    }
                    else {
                        decriptionTxt = (
                            <>
                                <p>1. {assignedToErrorVal}</p>
                                <p>2. Please select the Cost Center.</p>
                            </>
                        );
                        let isExist = assignedToError?.length ? assignedToError?.filter((item?: any) => item?.fleetId == purchaseOrderStepperData?.fleetRequestDetailId) : []
                        if (!isExist?.length) {
                            let obj: any = {}
                            obj.fleetId = purchaseOrderStepperData?.fleetRequestDetailId
                            obj.error = assignedToErrorVal
                            assignedToError?.push(obj)
                            setAssignedToError(assignedToError)
                        }
                    }
                } else if (itemType == CONSTANTS.AFEREQUEST) {
                    if ((!purchaseOrderStepperData?.assignedTo?.trim()?.length || purchaseOrderStepperData?.assignedTo == "Unassigned")) {
                        decriptionTxt = (
                            <>
                                <p>{assignedToErrorVal}</p>
                            </>
                        );
                        let isExist = assignedToError?.length ? assignedToError?.filter((item?: any) => item?.fleetId == purchaseOrderStepperData?.fleetRequestDetailId) : []
                        if (!isExist?.length) {
                            let obj: any = {}
                            obj.fleetId = purchaseOrderStepperData?.fleetRequestDetailId
                            obj.error = assignedToErrorVal
                            assignedToError?.push(obj)
                            setAssignedToError(assignedToError)
                        }
                    }
                }

                popupValue(decriptionTxt)

                isValid = false
            } else {
                isValid = true
                if (itemType == CONSTANTS.REQUISITION) {
                    setAssignedToError("")
                } else {
                    setAssignedToError([])
                }
            }
            for (let i = 0; i < groupTemp?.length; i++) {
                for (let j = 0; j < groupTemp[i]?.Details?.length; j++) {
                    if (groupTemp[i]?.Details[j]?.commentError?.length && groupTemp[i]?.Details[j]?.poFleetRequestTaskListTrackingId == Id) {
                        isValid = false
                    }
                }
            }
        }
        if (isValid) {
            let taskListValue: any = []
            if (Id != null) {
                for (let i = 0; i < groupTemp?.length; i++) {
                    groupTemp[i]?.Details?.map((detailTemp: any) => {
                        if ((detailTemp?.poFleetRequestTaskListTrackingId == Id)) {
                            changedValues.push(detailTemp)
                        }
                    })
                }
                if (changedValues?.length > 0) {
                    for (let i = 0; i < changedValues?.length; i++) {
                        let taskListValueTemp = {
                            poFleetRequestTaskListTrackingId: parseInt(changedValues[i]?.poFleetRequestTaskListTrackingId),
                            fleetDetailId: parseInt(changedValues[i]?.fleetDetailId),
                            stepId: parseInt(changedValues[i]?.stepId),
                            step: changedValues[i]?.step,
                            seqNo: parseInt(changedValues[i]?.seqNo),
                            taskDescription: changedValues[i]?.taskDescription,
                            taskStatus: changedValues[i]?.taskStatus,
                            isApplicable: changedValues[i]?.isApplicable ? false : true,
                            comment: changedValues[i]?.comment,
                            completedBy: userDetails?.emailId,
                            completedOn: changedValues[i]?.completedOn ? Moment(changedValues[i]?.completedOn).format("YYYY-MM-DD") : null,
                            created: changedValues[i]?.created ? Moment(changedValues[i]?.created).format("YYYY-MM-DD") : null,
                            parentSeqNo: changedValues[i]?.parentSeqNo ? changedValues[i]?.parentSeqNo : null
                        }
                        taskListValue?.push(taskListValueTemp)
                    }
                }
            }
            if (itemType == CONSTANTS.REQUISITION) {
                let saveValue = {
                    poFleetDetailId: Id == null ? (attachmentChangeFleetId ? parseInt(attachmentChangeFleetId) : parseInt(purchaseOrderStepperData?.fleetRequestDetailId)) : parseInt(changedValues[0]?.fleetDetailId),
                    savedBy: userDetails?.emailId,
                    poFleetRequestTaskListTrackings: Id == null ? [] : taskListValue,
                    assignedTo: purchaseOrderStepperData?.assignedTo,
                    orderRequestId: parseInt(purchaseOrderStepperData?.orderRequestId),
                    assetReceivedDetail: null,
                    orderAttachments: attachmentsList,
                    itemAttachments: linkedAttachmentTemp[0]?.attachments,
                    estDeliveryDate: purchaseOrderStepperData?.estDeliveryDate ? Moment(purchaseOrderStepperData?.estDeliveryDate).format("YYYY-MM-DD") : moment().add(15, 'd').toDate(),
                    actualDeliveryDate: purchaseOrderStepperData?.actualDeliveryDate ? Moment(purchaseOrderStepperData?.actualDeliveryDate).format("YYYY-MM-DD") : null
                }
                dispatch(getSaveAdminTaskvalue(saveValue))
            } else {
                let assetSaveValue = {
                    poFleetDetailId: Id == null ? (attachmentChangeFleetId ? parseInt(attachmentChangeFleetId) : parseInt(purchaseOrderStepperData?.fleetRequestDetailId)) : parseInt(changedValues[0]?.fleetDetailId),
                    savedBy: userDetails?.emailId,
                    poFleetRequestTaskListTrackings: Id == null ? [] : taskListValue,
                    assignedTo: purchaseOrderStepperData?.assignedTo,
                    orderRequestId: parseInt(purchaseOrderStepperData?.orderRequestId),
                    assetReceivedDetail: null,
                    orderAttachments: attachmentsList,                 
                    itemAttachments: linkedAttachmentTemp[0]?.attachments,
                    estDeliveryDate: purchaseOrderStepperData?.estDeliveryDate ? Moment(purchaseOrderStepperData?.estDeliveryDate).format("YYYY-MM-DD") : null,
                    actualDeliveryDate: purchaseOrderStepperData?.actualDeliveryDate ? Moment(purchaseOrderStepperData?.actualDeliveryDate).format("YYYY-MM-DD") : null,
                    newAssetNumber: purchaseOrderStepperData?.newAssetNumber ? parseInt(purchaseOrderStepperData?.newAssetNumber) : 0,
                    assetDetermination: purchaseOrderStepperData?.assetDetermination ? (purchaseOrderStepperData?.assetDetermination ? true : false) : false,
                    titleExists : purchaseOrderStepperData?.titleExists
                }
                setAssetDeterminationValue(null)
                setNewAssetValue(null)
                if(assetOrderHeaderDetail?.orderRequestType === CONSTANTS.AFEREQUEST){
                    dispatch(getSaveAfeAdminTaskvalue(assetSaveValue))
                }else
                    dispatch(getSaveAssetAdminTaskvalue(assetSaveValue))
            }
        }

    }

    const handleClickCancel = () => {
        let decriptionTxt = (
            <>
                <p>If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?</p>
            </>
        );

        setPopupcontent({
            ...Popupcontent,
            titleImg: ConfirmationBee,
            title: "UNSAVED CHANGES",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            outlineBtnText: "No",
            primaryBtnText: "Yes",
            isSingleConfirmationBtn: false,
            popupOutlinebtnOnclick: () => {
                setPopupcontent({ ...Popupcontent, isDialogVisible: false })
            },
            popupPrimarybtnOnclick: () => {
                setPopupcontent({ ...Popupcontent, isDialogVisible: false })
                dispatchNav("Home");
                navigate('/ordermanagement');
            }
        });
    }
    const hideDialog = useCallback(
        () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
        [Popupcontent]
    );

    const handleClickReset = (isApplicable: any, date: any, comment:any, Id: any, Step: any) => {
        const isNA = isDisableOncomplete() && isApplicable
        if((isDisableOncomplete() && (date && comment != "")) || isNA){
            let decriptionTxt = (
                <>
                    <p>Are you sure you want to reset this task?</p>
                </>
            );
    
            setPopupcontent({
                ...Popupcontent,
                titleImg: ConfirmationBee,
                title: "CONFIRMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "No",
                primaryBtnText: "Yes",
                isSingleConfirmationBtn: false,
                popupOutlinebtnOnclick: () => {
                    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
                },
                popupPrimarybtnOnclick: () => {
                    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
                    handleClearCompletedOn(isApplicable, date, comment, Id, Step)
                }
            });
        }else{
            handleClearCompletedOn(isApplicable, date, comment, Id, Step)
        }
    }

    const isDisableOncomplete = useCallback(() => {
        let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == purchaseOrderStepperData?.fleetRequestDetailId)
        if (val?.length) {
            if (val[0]?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || val[0]?.itemStatus == CONSTANTS.ORDER_STATUS.TRANSFER_COMPLETE || val[0]?.itemStatus == CONSTANTS.ORDER_STATUS.REACTIVATION_COMPLETE || val[0]?.itemStatus == CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE || val[0]?.itemStatus == CONSTANTS.ITEM_STATUS.AFE_COMPLETE || val[0]?.itemStatus == CONSTANTS?.ORDER_STATUS.RETURNED_TO_REQUESTOR || val[0]?.itemStatus == CONSTANTS.ITEM_STATUS.CANCELLED) {
                return true
            } else {
                return false
            }
        }
        else if (purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.TRANSFER_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REACTIVATION_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ITEM_STATUS.AFE_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ITEM_STATUS.CANCELLED) {
            return true
        } else {
            return false
        }
    },[purchaseOrderStepperData, savedStatus])

    return (
        <AdminTask
            groupedItemDetail={groupedItemDetail}
            handleClickCancel={handleClickCancel}
            Popupcontent={Popupcontent}
            popupOutlinebtnOnclick={props.popupOutlinebtnOnclick}
            hideDialog={hideDialog}
            popupPrimarybtnOnclick={props.popupPrimarybtnOnclick}
            handleClickComment={handleClickComment}
            handleBlurComment={handleBlurComment}
            onChangeComment={onChangeComment}
            handleChangeToggle={handleChangeToggle}
            handleDateChange={handleDateChange}
            purchaseOrderStepperData={purchaseOrderStepperData}
            savedStatus={savedStatus}
            isDisableOncomplete={isDisableOncomplete}
            onChangeEstDeliveryDate={onChangeEstDeliveryDate}
            onChangeActDeliveryDate={onChangeActDeliveryDate}
            clearEstDeliveryDate={clearEstDeliveryDate}
            clearActDeliveryDate={clearActDeliveryDate}
            handleClearCompletedOn={handleClearCompletedOn}
            itemType={itemType}
            isComplete={isComplete}
            handleClickReset={handleClickReset}
        />
    )
}

export default AdminTaskContainer